//
import { ModuleLayout } from "@/components/reusable_components/next"

//
import GBankListView from "@/views/General/GBank/GBankList"
import GBankCreateView from "@/views/General/GBank/GBankCreate"
import GBankUpdateView from "@/views/General/GBank/GBankUpdate"

//
export default {
  path: "g_bank",
  component: ModuleLayout,
  children: [
    {
      name: "g-bank-list",
      path: "",
      component: GBankListView,
    },
    {
      name: "g-bank-create",
      path: "create",
      component: GBankCreateView,
      meta: {
        title: "Crear banco"
      },
    },
    {
      name: "g-bank-update",
      path: ":id",
      component: GBankUpdateView,
      meta: {
        title: "Detalle de banco"
      },
    },
  ],
  meta: {
    title: "Bancos"
  },
}